import {api} from "./api";
import {MODERATOR_FAQ} from "../mock/URLs";
import {GetFaqResponse} from "../types/faq";

type Faq = {
  params: {
    page: number;
    page_size: number;
    search?: string;
  }
}

export const getFaq = async ({params}: Faq) => {
  try {
    const {data} = await api.get<GetFaqResponse>(MODERATOR_FAQ, {
      params
    })
    return data;
  } catch (e) {
    throw e
  }
}

export const getFaqById = async (id: number) => {
  try {
    const {data} = await api.get(`${MODERATOR_FAQ}${id}/`)
    return data.data;
  } catch (e) {
    throw e
  }
}

export const createFaq = async (formData: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_FAQ, formData)
    return data;
  } catch (e) {
    throw e
  }
}

export const updateFaq = async (id: number, formData: FormData) => {
  try {
    const {data} = await api.patch(`${MODERATOR_FAQ}${id}/`, formData)
    return data;
  } catch (e) {
    throw e
  }
}